/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { getFlowIdFromUrl } from '@utils/flows';

import { useToast } from '@hooks/useToast';
import { useChargerFlows } from '@features/chargerFlows/queries';
import { useSetEditChargerFlow } from '@features/chargerFlows/store';
import { useAllPaymentErrorCodes } from '@features/paymentErrorCodes/queries';
import { useSetAllPaymentsErrorCodesStore } from '@features/paymentErrorCodes/store';

import FlowEdit from '@components/Flows/FlowEdit/FlowEdit';
import LoadingAnimation from '@components/LoadingAnimation';

import s from './FlowEditPage.module.css';
import type { ChargerFlow } from '@models/chargerFlows';

function FlowEditPage() {
  const toast = useToast();
  const navigate = useNavigate();
  const flowId = getFlowIdFromUrl();
  const setEditChargerFlowStore = useSetEditChargerFlow();
  const {
    data: chargerFlowData,
    isLoading: isChargerFlowLoading,
    isError: isChargerFlowError,
  } = useChargerFlows(flowId);
  const setAllErrorsStore = useSetAllPaymentsErrorCodesStore();
  const {
    data: errorCodesData,
    isLoading: isErrorCodesLoading,
    isError: isErrorCodesError,
  } = useAllPaymentErrorCodes();

  // Handle errors
  useEffect(() => {
    if (isChargerFlowError) {
      navigate('/dashboard/charger-flows');
      toast.error('There was an issue fetching the charger flow with ID: ' + flowId);
    }
    if (isChargerFlowError) {
      navigate('/dashboard/charger-flows');
      toast.error('There was an issue fetching error-codes');
    }
  }, [isChargerFlowError, isErrorCodesError]);

  // Store API data to Zustand stroe
  useEffect(() => {
    if (chargerFlowData) {
      setEditChargerFlowStore(chargerFlowData);
    }
    if (errorCodesData) {
      setAllErrorsStore(errorCodesData.data);
    }
  }, [chargerFlowData, errorCodesData]);

  if (isChargerFlowLoading || isErrorCodesLoading) {
    return <LoadingAnimation />;
  }

  return (
    <div className={s.container}>
      <FlowEdit chargerFlow={chargerFlowData as ChargerFlow} />
    </div>
  );
}

export default FlowEditPage;
